// Registra i componenti facoltativi quando esistono nel DOM, inclusi i frammenti AJAX.
// I moduli essenziali di menu, ricerca, varianti, quick-add e carrello restano immediati.
const config = document.getElementById('kg-component-assets');
const sources = config ? JSON.parse(config.textContent) : {};
const waiting = new Map(Object.entries(sources));
const pending = new Set();
let scheduled = false;
function scan(root) {
  for (const [selector, url] of waiting) {
    if (pending.has(selector)) continue;
    if (!root.matches?.(selector) && !root.querySelector?.(selector)) continue;
    pending.add(selector);
    import(url).then(() => {
      waiting.delete(selector);
      if (!waiting.size) observer.disconnect();
    }).catch((error) => {
      pending.delete(selector);
      console.error('[kg-component]', selector, error);
    });
  }
}
const added = new Set();
const observer = new MutationObserver((records) => {
  for (const record of records) for (const node of record.addedNodes) {
    if (node.nodeType === Node.ELEMENT_NODE) added.add(node);
  }
  if (!added.size || scheduled) return;
  scheduled = true;
  queueMicrotask(() => {
    scheduled = false;
    for (const node of added) {
      if (!node.isConnected) continue;
      let parent = node.parentElement;
      while (parent && !added.has(parent)) parent = parent.parentElement;
      // Un solo passaggio per sottoalbero inserito, non uno per ciascun discendente.
      if (!parent) scan(node);
    }
    added.clear();
  });
});
observer.observe(document.documentElement, { childList: true, subtree: true });
scan(document);
